import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { TopicSetCard } from './topicset-card';
import themeCss from '../css/cards.m.css';
const factory = create({
    theme
}).properties();
export const TopicSetCards = factory(({ properties, middleware: { theme } }) => {
    const css = theme.classes(themeCss);
    const { path, topic } = properties();
    const topicsets = topic.children.filter((k) => 'topicset' in k);
    const kids = topicsets.map((k, index) => w(TopicSetCard, { path, topic: k.topicset, index }));
    return v('div', { id: `dashboard-cards-container-${path}`, classes: [theme.variant(), css.root] }, kids);
});
export default TopicSetCards;
